import { laptopMax, mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 10px;
  background-color: ${({ theme }) => theme.background};
  border: 2px solid ${({ theme }) => theme.keyline};
  padding: 20px;
  color: ${({ theme }) => theme.textDark};
  display: flex;
  gap: 30px;
  justify-content: space-between;

  h3 b {
    color: ${({ theme }) => theme.primary};
  }

  @media (${laptopMax}) {
    flex-direction: column-reverse;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 20px 15px;
  }
`;

export const LeftSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (${laptopMax}) {
    align-items: center;
  }
`;

export const ViewBox = styled.div`
  background-color: ${({ theme }) => theme.backgroundLighter};
  width: 100%;
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;

  @media (${mobileXXLargeMax}) {
    width: calc(100% + 30px);
    padding: 10px;
    margin-left: -15px;
    margin-right: -15px;
    border-radius: 0;
  }
`;

export const RosetteContainer = styled.div`
  position: relative;
  margin: 0 auto 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RosetteText = styled.p`
  width: 100%;
  text-align: center;
  position: absolute;
  top: 34px;
  font-weight: bold;
  font-size: 32px;
  font-family: ${platform.headingFont};
`;

export const InfoBar = styled.div`
  background-color: ${({ theme }) => theme.background};
  border-radius: 90px;
  border: 1px solid ${({ theme }) => theme.keyline};
  display: inline-flex;
  color: ${({ theme }) => theme.textDark};
  text-align: center;
  padding: 10px 15px;

  & > div {
    border-left: 1px solid ${({ theme }) => theme.keyline};
    padding: 0 30px;
  }

  & > div:first-child {
    border-left: none;
  }

  h5 {
    font-size: 20px;
  }

  @media (${tabletMax}) {
    & > div {
      padding: 0 15px;
    }

    h5 {
      font-size: 16px;
    }

    p {
      font-size: 12px;
    }
  }
`;
